module.exports = __webpack_public_path__ + "static/img/InvitationCode.278d6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Instruction/InvitationCode.png
// module id = 1741
// module chunks = 34 35